/* NewsEntryList Messages
 *
 * This contains all the text for NewsEntryList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  saveSuccess: {
    id: 'app.components.NewsEntryList.saveSuccess',
    defaultMessage: 'News entry has been successfully created.',
  },
  saveFailure: {
    id: 'app.components.NewsEntryList.saveFailure',
    defaultMessage: 'Error. The news entry could not be created.',
  },
  title: {
    id: 'app.components.NewsEntryList.title',
    defaultMessage: 'Create News Entry',
  },
  saveButton: {
    id: 'app.components.NewsEntryList.saveButton',
    defaultMessage: 'Save',
  },
});
